module.exports = __webpack_public_path__ + "img/square-check-green.5ab01d44.svg";